import {Component, Inject, OnInit} from '@angular/core';
import {SocietyValidationAccountDialogData, SocietyValidationAccountOrigin} from "@core/shared/models/society-validation-account";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'app-core-sca-validation-required-dialog',
    templateUrl: './sca-validation-required-dialog.component.html',
    styleUrl: './sca-validation-required-dialog.component.scss',
    standalone: false
})
export class ScaValidationRequiredDialogComponent implements OnInit {

    public constructor(
        @Inject(MAT_DIALOG_DATA) public data: SocietyValidationAccountDialogData
    ) {}

    ngOnInit() {}

    public redirectToSca(): void {

        const hasQuery = this.data.redirectUrl.includes('?');

        const separator: string = hasQuery ? '&' : '?';

        const params: object = {
            returnUrl: this.data.returnUrl
        };

        const paramString: string = Object.entries(params).map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');

        window.location.href = this.data.redirectUrl + (paramString ? separator + paramString : '');
    }

    get description(): string {

        switch (this.data.origin){

            case SocietyValidationAccountOrigin.SocietyDataUpdate:

                return 'sca.societyDataUpdate.description.value';

            default:

                return 'sca.activation.description.value';
        }
    }
}
